import { useEffect, useRef } from 'react';
import { ChatMessage } from '../types/askStanley.types';

export const useChatScroll = (messages: ChatMessage[]) => {
    const messagesContainerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (messagesContainerRef.current) {
            messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
        }
    }, [messages]);

    return messagesContainerRef;
};
